import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { ApiUrl } from '../constants/api-url';
import { buyerInfo } from '../constants/buyer_info';
import { catchError, of, tap } from 'rxjs';


@Injectable({
  providedIn: 'any'
})
export class CampaignService {
  private httpClient = inject(HttpClient);
  buyerObj: any;

  skipFailedCampaigns(requestParams: any, token: any) {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID,
      '__RequestVerificationToken': token || ''
    });

    return this.httpClient.post(`${buyerInfo.BulkUserUploadCampaignMicorserviceUrl}${ApiUrl.SKIP_FAILED_CAMPAIGNS}`, requestParams, { headers }).pipe(
      catchError((error) => {
        return of({ error: true, message: error?.error?.message || error?.message || 'Request failed', status: error?.status });
      })
    );

  }

  getCrowdStrikeScanDetails(requestParams: any, token: any) {
    const headers = new HttpHeaders({
      'Accept': '*/*',
      'encType': "multipart/form-data",
      '__RequestVerificationToken': token
    });
    let csvUploadRequest = new FormData();
    csvUploadRequest.append('file', requestParams.File, requestParams.File.name);

    return this.httpClient.post(`${ApiUrl.GET_CROWDSTRIKE_SCAN_DETAILS}`, csvUploadRequest, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })


    );

  }

  /**
   * Gets the campaign template download URL from Azure Blob Storage
   * @param type Campaign type: 'Organization' or 'User'
   * @returns Observable with downloadUrl, fileName, and templateType
   */
  getCampaignTemplateUrl(type: string = 'Organization') {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.httpClient.get<{ downloadUrl: string; fileName: string; templateType: string }>(
      `${ApiUrl.GET_CAMPAIGN_TEMPLATE_URL}?type=${type}`, 
      { headers }
    ).pipe(
      catchError((error) => {
        console.error('Error fetching campaign template URL:', error);
        return of(error);
      })
    );
  }


  csvUploadInCampaign(requestParams: any) {
    const headers = new HttpHeaders({
      'Accept': 'application/json', 'encType': "multipart/form-data",
      'x-api-buyerid': requestParams.BuyerId,
      'x-api-userid': requestParams.userId
    });
    let csvUploadRequest = new FormData();
    csvUploadRequest.append('Name', requestParams.Name);
    csvUploadRequest.append('Description', requestParams.Description);
    csvUploadRequest.append('File', requestParams.File);

    return this.httpClient.post(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.CSV_UPLOAD_IN_CAMPAIGN_URL_V1}`, csvUploadRequest, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })
    );
  }

  bulkUserCsvUploadInCampaign(requestParams: any) {
    const headers = new HttpHeaders({
      'Accept': 'application/json', 'encType': "multipart/form-data",
      'x-api-buyerid': requestParams.BuyerId,
      'x-api-userid': requestParams.userId
    });
    let csvUploadRequest = new FormData();
    csvUploadRequest.append('Name', requestParams.Name);
    csvUploadRequest.append('Description', requestParams.Description);
    csvUploadRequest.append('File', requestParams.File);
    csvUploadRequest.append('DefaultApp', requestParams.DefaultApp);

    return this.httpClient.post(`${buyerInfo.BulkUserUploadCampaignMicorserviceUrl}${ApiUrl.USER_CSV_UPLOAD_BULK}`, csvUploadRequest, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })


    );

  }

  // list for organation list 
  getCampaignDetailsData(requestObject: any): any {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.get(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.GET_CAMPAIGNDETAILS_DATA_URL}${requestObject}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })
    );
  }

  // failed list for organation 
  getFailedCampaignDetailsData(campaignId: any): any {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });
    return this.httpClient.get(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.GET_FAILED_CAMPAIGNDETAILS_DATA_URL}campaignId=${campaignId}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })
    );
  }

  getBulkUserCampaignData(requestObject: any, headers: any): any {
    return this.httpClient.get(`${buyerInfo.BulkUserUploadCampaignMicorserviceUrl}${ApiUrl.GET_CAMPAIGN_BULK_LOAD_DETAILS_DATA_URL}${requestObject}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }

  // list of matching supplires 
  getMatchingSuppliersData(requestObject: any, headers: any): any {

    return this.httpClient.get(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.GET_MATCHING_SUPPLIERS_DATA_URL}${requestObject}`, { headers }).pipe(

      catchError((error) => {
        return of(error);
      })

    );
  }

  getMatchingUserDetailsByEmail(requestObject: any): any {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });
    return this.httpClient.post(`${buyerInfo.BulkUserUploadCampaignMicorserviceUrl}${ApiUrl.GET_MATCHING_USER_BY_EMAIL_URL}`, requestObject, { headers })
      .pipe(
        catchError((error) => {
          return of(error);
        })
      );
  }



  // save validation of matching supplires 
  setMatchingSuppliers(formData: FormData): any {
    // Do NOT set Content-Type header - browser sets it automatically with multipart boundary
    const headers = new HttpHeaders({
      'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });
    return this.httpClient.post(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.SET_MATCHING_SUPPLIERS_URL}`, formData, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }

  setMatchingBulkUsers(request: any): any {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });
    return this.httpClient.post(`${buyerInfo.BulkUserUploadCampaignMicorserviceUrl}${ApiUrl.GET_UPDATE_BULK_USER_CURATION_STATUS}`, request, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }

  //get search forms
  getCampaignStatus(requestObj: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.get(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.GET_CAMPAIGN_STATUS_URL}${requestObj}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }
  getBuyerSubscriptions() {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.httpClient.get(`${ApiUrl.GET_BUYER_SUBSCRIPTIONS_URL}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }

  getUserSubscriptions() {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.get(`${ApiUrl.GET_USER_SUBSCRIPTIONS_URL}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })
    );
  }
  getBuyerForms(searchString: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.httpClient.get(`${ApiUrl.GET_BUYER_FORMS}?searchText=${encodeURIComponent(searchString || '')}&matchCase=false`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }
  getApprovers() {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.httpClient.get(`${ApiUrl.GET_APPROVERS}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }
  saveActionPreference(requestObject: object) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', 'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.post(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.POST_SAVE_ACTION_PREFERENCE}`, requestObject, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }

  saveBulkUserActionPreference(requestObject: object) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', 'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });
    return this.httpClient.post(`${buyerInfo.BulkUserUploadCampaignMicorserviceUrl}${ApiUrl.BULK_USER_UPDATE_ACTION_PREFERENCE}`, requestObject, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })
    );
  }

  downloadFile(campaignId: any, buyerinfo: any) {
    const headers = new HttpHeaders({
      'Content-Type': '/', 'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.get(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.DOWNLOAD_SUCCESS_ISSUES}?campaignId=${campaignId}`, { responseType: 'arraybuffer', headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }

  downloadInvitationStatusForCsv(campaignId: any) {
    const headers = new HttpHeaders({
      'Content-Type': '/', 'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.get(`${buyerInfo.BulkUserUploadCampaignMicorserviceUrl}${ApiUrl.GET_INVITATION_STATUS_FOR_CSV_DOWNLOAD}?campaignId=${campaignId}`, { responseType: 'arraybuffer', headers }).pipe(
      catchError((error) => {
        return of(error);
      })
    );
  }

  getFailedEnrollmentData(campaignId?: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', 'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    const campaignIdParam = campaignId ? `?CampaignId=${campaignId}` : ''

    return this.httpClient.get(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.GET_FAILED_ENROLLMENTS}${campaignIdParam}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }

  getFailedEnrollmentsForBulkUser() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', 'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.get(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.GET_FAILED_USER_ENROLLMENTS}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }

  getInviteSuppliersByCampaignId(requestparams: any) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json', 'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.get(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.GET_INVITED_SUPPLIERS}${requestparams}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }

  getFilteredInvitedUsers(requestparams: any) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json', 'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.get(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.GET_ALL_USER_ENROLLMENTS}${requestparams}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }

  getInviteSupplierStatus(invitedSupplierId: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', 'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.get(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.GET_INVITED_SUPPLIER_STATUS}invitedSupplierId=${invitedSupplierId}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }
  getOrgSubscriptionsStatus(exostarId: any) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.httpClient.get(`${ApiUrl.GET_ORGANIZATION_SUBSCRIPTIONS}${exostarId}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }
  getEnrollmentStatus(requestParam: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', 'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });
     return this.httpClient.post(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.GET_ENROLLMENT_STATUS}`, requestParam, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }
  getCurrentFormStatus(requestparam: any) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.httpClient.get(`${ApiUrl.GET_CURRENT_FORM_STATUS}${requestparam}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }

  deleteCampaign(requestParam: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', 'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.post(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.DELETE_CAMPAIGN}?campaignId=${requestParam.campaignId}`, {}, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }

  campaignRetry(request: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', 'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.post(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.CAMPAIGN_RETRY}`, request, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }

  bulkDeleteUserCampaign(requestParam: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', 'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.post(`${buyerInfo.BulkUserUploadCampaignMicorserviceUrl}${ApiUrl.BULK_USER_DELETE_CAMPAIGN}?campaignId=${requestParam.campaignId}`, {}, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }
  getCampaignList(buyer: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-buyerid': buyer.hostOrganizationUUID,
      'x-api-userid': buyer.userID
    });

    return this.httpClient.get(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.GET_CAMPAIGN_LIST_URL}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }

  getUserCampaignList(buyer: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-buyerid': buyer.hostOrganizationUUID,
      'x-api-userid': buyer.userID
    });

    return this.httpClient.get(`${buyerInfo.BulkUserUploadCampaignMicorserviceUrl}${ApiUrl.GET_BULK_LOAD_LIST_URL}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );


  }

  bulkDeleteCampaign(requestParam: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', 'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.post(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.BULK_DELETE_CAMPAIGN}`, requestParam, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }

  bulkLoadUserDeleteCampaign(requestParam: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', 'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.post(`${buyerInfo.BulkUserUploadCampaignMicorserviceUrl}${ApiUrl.BULK_USER_UPLOAD_DELETE_CAMPAIGN}`, requestParam, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }


  bulkLoadUserGetStatus(campaignId: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.get(`${buyerInfo.BulkUserUploadCampaignMicorserviceUrl}${ApiUrl.GET_BULK_LOAD_STATUS}${campaignId}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }

  bulkLoadUserUpdateCampaignStatus(campaignId: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.post(`${buyerInfo.BulkUserUploadCampaignMicorserviceUrl}${ApiUrl.UPLOAD_BULK_LOAD_CAMPAIGN_STATUS}${campaignId}`, {}, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })

    );
  }

  getDataCorrectionsTabData(campaignId: string, pageNumber: number = 1, pageSize: number = 50) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.get(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.GET_DATA_CORRECTIONS_TAB_DATA}campaignId=${campaignId}&buyerId=${buyerInfo.hostOrganizationUUID}&pageNumber=${pageNumber}&pageSize=${pageSize}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })
    );
  }

  fetchSingleInviteData( id: any ) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.get(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.FETCH_SINGLE_INVITE_DATA}${id}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })
    );
  }

  reValidateRecord(data: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.put(`${buyerInfo.CampaignMicroserviceUrl}${ApiUrl.REVALIDATE_CAMPAIGN_DATA}`, data, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })
    );
  }

  getDataCorrectionsColumnMappingData() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-buyerid': buyerInfo.hostOrganizationUUID,
      'x-api-userid': buyerInfo.userID
    });

    return this.httpClient.get(`${buyerInfo.BulkUserUploadCampaignMicorserviceUrl}${ApiUrl.GET_DATA_CORRECTIONS_COLUMN_MAPPING_DATA}`, { headers }).pipe(
      catchError((error) => {
        return of(error);
      })
    );
  }

}
